module.exports = __webpack_public_path__ + "img/image6.37853cb2.jpg";